import React, { useEffect, useState } from "react";
import { Title } from "./EmployeeDetails";
import { CreateButton, LongButton } from "../../../../Components/Utils/Buttons";
import { Button, Modal, notification } from "antd";
import { NuDate, NuTextArea, NuUpload } from "../../../../Components/Utils/Input";
import { useFormik } from "formik";
import axiosInstance from "../../../../Services/axiosCommon";
import { useParams } from "react-router-dom";
import DeleteIcon from "../../../../Components/Icons/Delete";
import EditIcon from "../../../../Components/Icons/Edit";
import Att from "../../../../Components/Icons/Att";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";
import DownloadIcon from "../../../../Components/Icons/Download";
const filetype = ["docx", "doc", "xlsx", "xls", "pdf", "txt", "pptx","mp4", "mov", "wmv", "avi", "flv", "mkv"];



function Documents(item) {
  const { officeId } = useParams();
  const { ViewEmployeeId } = useParams();

  const [create, setCreate] = useState({
    
    branchId: officeId,
    employeeId:ViewEmployeeId,
    
  });
  const [EmployeeAtt, setEmployeeAtt] = useState([]);

  async function getMembersByProject(officeId) {
    await axiosInstance
      .get(`/employee-documents/${officeId}/details/${ViewEmployeeId}/employee`)
      .then((res) => {
        setEmployeeAtt(res?.data?.data?.data);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          setEmployeeAtt([]);
        }
        console.log(error);
      });
  }
  useEffect(() => {
    getMembersByProject(officeId);
  }, []);
    const [show, setShow] = useState(false);
  
  const [openAll, setOpenAll] = useState(false);
  const [employee, setEmployee] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState([]);

  function OpenFunction(item) {
    setEmployee(item?.id);
    setCreate({
      branchId: officeId,
      employeeId:ViewEmployeeId,
      
    });
    setEditMode(true);
    setOpenAll(true);
  }
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: create,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (value,{resetForm}) => {   
      setIsLoading(true); 
      let formData =new FormData()
      formData.append("json_data",JSON.stringify(value))
      if(selectedFile !== null){
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      }else{
        formData.append("attachments",[])
      } 

      axiosInstance
      .post("/employee-documents/", formData)
        .then((res) => {
          console.log(res);
          if (res.status === 201 || res.data.status == true) {
            getMembersByProject(officeId);
            setIsLoading(false); 
            resetForm();
            api.success({
              message: `Attachment Creation successfully`,
              description: res?.data?.msg || "Added In Tittle",
              placement: "bottomRight",
            });
            CloseFunction();
          } else {
            setIsLoading(false); 
            api.error({
              message: `Tittle Creation failed`,
              description: res?.data?.msg || "Network error",
              placement: "bottomRight",
            });
          }
        })
        .catch((err) => {
          setIsLoading(false); 
          api.error({
            message: `Tittle Creation failed`,
            description: err?.data?.msg || "Sever error (or) Network error",
            placement: "bottomRight",
          });
        });
    },
  });
  function CloseFunction() {
    setCreate({
      branchId: officeId,
      employeeId:ViewEmployeeId,
      
    });
    setEmployee("");
    setOpenAll(false);
  }
  const handleDeleteComment = (id) => {
    Modal.confirm({
      title: "Are you sure you want to delete this Document?",
      width: "25%",
      centered: true,
      okText: "Yes",
      cancelText: "No",
      onOk: () => {
        axiosInstance
          .delete(`/employee-documents/${id}`)
          .then((res) => {
            if (res.status === 200 || res.data.status === true) {
              api.success({
                message: "Deleted",
                description: res?.data?.msg || "Document deleted successfully",
                placement: "bottomRight",
              });
              getMembersByProject(officeId);
            }
          })
          .catch((err) => console.error(err));
      },
    });
  };
   

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = []
    files.map(item=>{
      if (item.size < maxFileSize ){
        fileArr.push(item)
      }else{
        api.warning({
          message: `File Size to big`,
          description: `${item.attachmentName} is Removed and not Uploaded`,
          placement: "bottomRight",
        });
      }
    })    
    let tempArr = []
    setSelectedFile(fileArr);
    files.map(item=>{
      if (item.size < maxFileSize ){
      let fileName = item?.attachmentName
      let fileExtention =  fileName?.split(".").reverse()[0]
      if(filetype?.includes(fileExtention)){
        tempArr.push(fileName)
      }else{
        let x = URL.createObjectURL(item)
        tempArr.push(x)
      }
    }
    })
    setImage(tempArr)
  }

  const removeImages = (value) => {
  let List = selectedFile.filter((item) => item?.name !== value);
  setSelectedFile([...List]);

  let tempArr = [];
  List.forEach((item) => {
    let fileName = item?.name;
    tempArr.push(fileName);
  });

  setImage(tempArr);
};
const [attfile,setAttfile]=useState("")
 function showFile({file}){
  setAttfile(file)
  setShow(true)


 }

 const downloadAttachment = async () => {
  try {
    const fileName = attfile.split('/').pop();

    const response = await axiosInstance.get(attfile, {
      responseType: 'blob',
    });

    const blob = new Blob([response.data]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName || 'downloaded_file';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Download error:", error);
  }
};


  return (
        <div className=" w-full h-full py-3">
            <div className=' flex justify-between items-center'>
            <Title value="Documents : " />
                   <CreateButton handleClick={() => setOpenAll(true)} />
           
            </div>
            <div className='w-full h-[calc(100%-2.5rem)] mt-3  relative'>
              <div className=' w-full bg-textColor-main static text-white top-0'>
                <table className=' w-full '>
                  <thead>
                    <tr className=' w-full' >
                      <th className=' py-2 text-xs font-medium w-[5%] ' >Sl.No</th>
                      <th className=' py-2 text-xs font-medium w-[70%] text-left'>File Name</th>
                      <th className=' py-2 text-xs font-medium w-[15%]' >Size</th>
                      <th className=' py-2 text-xs font-medium w-[10%]'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
              {
                EmployeeAtt?.map((item, index) => (
                  <tr className="odd:bg-white even:bg-slate-50 " key={index}>
                    <td className="py-1 text-xs text-center font-medium w-[5%] text-[#4f4768]">
                      {" "}
                      {item?.sno || index + 1}
                    </td>
                    <td className="text-xs w-[70%] py-3 px-1 font-normal text-[#4f4768] truncate">
          <span className=" cursor-pointer" onClick={() => setShow(true)}>
            {item?.attachmentName || "-"}
          </span>
        </td>
        {/* <td className=" w-[10%] py-3 px-1 font-normal text-[#4f4768]">{item?.format || "-"}</td> */}
        <td className="text-xs w-[15%] py-3 px-1 text-center font-normal text-[#4f4768]">{ `${(item?.attachmentSize||0).toFixed(2)} KB `|| "-"}</td>
        <td className="text-xs w-[10%] py-3 px-4 flex justify-center items-center">
            <div className=" w-full flex text-center gap-2">
                <div className="cursor-pointer" onClick={()=>showFile({file:item.attachmentPath})}><Att color='green'/></div>
                <div className="cursor-pointer" onClick={()=>handleDeleteComment(item?.id
)}><DeleteIcon/></div>
            </div>
        </td>
                   
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div></div>
      </div>
       <Modal
              open={openAll}
              title={"Create Attachments"}
              width={"50%"}
              height={'80%'}
              className="my-modal"
              centered
              footer={[]}
              onCancel={CloseFunction}
            >
                    <form onSubmit={formik.handleSubmit} >
              <div className=" w-full flex justify-center items-center flex-wrap">
                
                   <Attachement
                                  handleChange={handleImageChange}
                                  preview={image || ""}
                                  width="w-full"
                                  label="Attach"
                                  multiple={true}
                                  removeImages={removeImages}
                                />
                 
                  <LongButton isLoading={isLoading} />
              </div>
              </form>
            </Modal>
    
      {/* <Modal
              open={show}
              title={"View Attachment"}
              width={"95%"}
              className="my-modal"
              centered
              onCancel={() => 
              {
                setAttfile("")
                setShow(false)
              }
              }
              footer={[]}
            >
              <div className=" w-full h-[calc(100vh-100px)] overflow-hidden flex justify-center items-center">
                 
                  {

                      <img src={attfile||""} alt="#" style={{width:"auto",height:'calc(100% - 10px)'}} />
                  }
                  
              </div>
              
            </Modal> */}
         <Modal
  open={show}
  title="View Attachment"
  width="95%"
  className="my-modal"
  centered
  onCancel={() => {
    setAttfile("");
    setShow(false);
  }}
  footer={[
    <Button
      key="download"
      type="primary"
      onClick={downloadAttachment}
      disabled={!attfile}
    >
        <DownloadIcon/>
        Download
    </Button>
  ]}
>
  <div className="w-full h-[calc(100vh-100px)] overflow-hidden flex justify-center items-center">
    <img
      src={attfile || ""}
      alt="Attachment"
      style={{ width: "auto", height: "calc(100% - 10px)" }}
    />
  </div>
</Modal>


            
       
    </div>
  );
}



export default Documents